
jQuery(function ($) {

    Shopify.Cart.ShippingCalculator.show({
        submitButton: "Calcular",
        submitButtonDisabled: "Calculando...",
        moneyFormat: moneyformat
    });

    function inputHandler(masks, max, event) {
        var c = event.target;
        var v = c.value.replace(/\D/g, "");
        var m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    }

    // ─── Inicia o spinner no botão visível (agora <button>) ─────────────────
    function iniciarLoading() {
        var btn = $('button.button-primary.get-rates-custom');
        btn.addClass('loading');
        btn.text('Calculando...');   // button usa .text(), não .val()
        btn.prop('disabled', true);
    }

    // ─── Remove o spinner do botão visível ───────────────────────────────────
    function pararLoading() {
        var btn = $('button.button-primary.get-rates-custom');
        btn.removeClass('loading');
        btn.text('Calcular');
        btn.prop('disabled', false);
    }

    // ─── Filtra fretes pagos quando existe opção grátis ──────────────────────
    function filtrarFreteGratis() {
        var wrapperResponse = $('#wrapper-response');
        if (!wrapperResponse.length) return;

        var observer = new MutationObserver(function (mutations, obs) {
            var rows = wrapperResponse.find('#shipping-rates li');
            if (!rows.length) return;

            var temGratis = false;

            rows.each(function () {
                var texto = $(this).text().toLowerCase();
                if (
                    texto.indexOf('frete grátis') !== -1 ||
                    texto.indexOf('gratis') !== -1 ||
                    texto.indexOf('free') !== -1 ||
                    texto.match(/r?\$?\s*0[,.]00/)
                ) {
                    temGratis = true;
                    return false;
                }
            });

            if (temGratis) {
                rows.each(function () {
                    var texto = $(this).text().toLowerCase();
                    var ehGratis =
                        texto.indexOf('frete grátis') !== -1 ||
                        texto.indexOf('gratis') !== -1 ||
                        texto.indexOf('free') !== -1 ||
                        texto.match(/r?\$?\s*0[,.]00/);

                    if (!ehGratis) {
                        $(this).hide();
                    }
                });
            }

            // Para de observar e remove o spinner após os fretes aparecerem
            obs.disconnect();
            pararLoading();
        });

        observer.observe(wrapperResponse[0], {
            childList: true,
            subtree: true
        });
    }
    // ─────────────────────────────────────────────────────────────────────────

    var carregaFrete = function (cep) {
        if ($("#address_zip").val().length != 9) {
            alert("Digite um cep válido");
            pararLoading();
        } else {
            $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
                if (!("erro" in dados)) {
                    if (!$("#shipping-calculator2.shiping-loaded")[0]) {
                        $("#shipping-calculator2").addClass("shiping-loaded");
                    }

                    var state;
                    var uf = dados.uf.toUpperCase();
                    switch (uf) {
                        case "AC": state = "Acre";                  break;
                        case "AL": state = "Alagoas";               break;
                        case "AM": state = "Amazonas";              break;
                        case "AP": state = "Amapá";                 break;
                        case "BA": state = "Bahia";                 break;
                        case "CE": state = "Ceará";                 break;
                        case "DF": state = "Distrito Federal";      break;
                        case "ES": state = "Espírito Santo";        break;
                        case "GO": state = "Goiás";                 break;
                        case "MA": state = "Maranhão";              break;
                        case "MG": state = "Minas Gerais";          break;
                        case "MS": state = "Mato Grosso do Sul";    break;
                        case "MT": state = "Mato Grosso";           break;
                        case "PA": state = "Pará";                  break;
                        case "PB": state = "Paraíba";               break;
                        case "PE": state = "Pernambuco";            break;
                        case "PI": state = "Piauí";                 break;
                        case "PR": state = "Paraná";                break;
                        case "RJ": state = "Rio de Janeiro";        break;
                        case "RN": state = "Rio Grande do Norte";   break;
                        case "RO": state = "Rondônia";              break;
                        case "RR": state = "Roraima";               break;
                        case "RS": state = "Rio Grande do Sul";     break;
                        case "SC": state = "Santa Catarina";        break;
                        case "SE": state = "Sergipe";               break;
                        case "SP": state = "São Paulo";             break;
                        case "TO": state = "Tocantíns";             break;
                    }

                    $('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);

                    // Ativa o observer ANTES de disparar o cálculo
                    // Ele vai remover o loading quando os fretes chegarem
                    filtrarFreteGratis();

                    $('.get-rates').trigger('click');

                } else {
                    alert("CEP não encontrado");
                    pararLoading();
                }

            }).fail(function () {
                alert("Consulta de CEP indisponivel no momento");
                pararLoading();
            });
        }
    };

    $(document).on('keypress', '#address_zip', function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $('button.button-primary.get-rates-custom').trigger("click");
        }
    });

    $(document).on('click', 'button.button-primary.get-rates-custom', function () {
        iniciarLoading();

        var variantid = $("#variantid");
        if (variantid[0]) {
            var variantvalue = $("#variantid").val();

            jQuery.getJSON('/cart.js', function (cart) {
                var cartItens = cart.item_count;
                if (cartItens == 0) {
                    console.log("adicionando...");
                    Shopify.addItem(variantvalue, 1, function () {
                        console.log('Success!!!');
                        carregaFrete($('#address_zip').val());
                        setTimeout(function () {
                            Shopify.removeItem(variantvalue);
                            console.log("Cart clean");
                        }, 10000);
                    });
                } else {
                    console.log(cartItens + " - itens no carrinho");
                    carregaFrete($('#address_zip').val());
                }
            });
        } else {
            carregaFrete($('#address_zip').val());
        }
    });
});
